<script>
import { getFileType } from '@/utils/common'
import { baseURL } from '@/utils/baseURL'

export default {
  data() {
    return {
      fileName: '',
      fullUrl: '',
      DocEditor: null
    }
  },
  mounted() {
    this.fileName = this.$route.query?.file || ''
    if (this.fileName !== '') {
      this.fullUrl = `${baseURL}/Files/${this.fileName}`
      this.setEditor(this.fullUrl)
    }
  },
  methods: {
    setEditor(fileUrl) {
      const fileType = getFileType(fileUrl)
      const key = 'test' + Math.random() + ''
      const fileTypeObj = {
        'docx': 'word',
        'xlsx': 'spreadsheet',
        'ppt': 'presentation'
      }
      const docType = fileTypeObj[fileType]
      const config = {
        document: {
          fileType,
          key,
          title: this.fileName,
          url: fileUrl, // 'https://hypadinterface.djplus.cn/Files/4.桐升社区森林防灭火工作网格化管理责任台账.xlsx', 'https://hypadinterface.djplus.cn/Files/桐升社区森林防火巡山护林员责任制度.docx'
          permissions: {
            comment: false,
            download: false,
            edit: false,
            fillForms: false,
            modifyContentControl: false,
            modifyFilter: false,
            print: true,
            review: false
          }
        },
        editorConfig: {
          lang: 'zh-CN',
          mode: 'view',
          user: {
            name: 'user',
            id: 121
          },
          customization: {
            chat: false,
            comments: false,
            compactHeader: false,
            compactToolbar: false,
            help: false,
            toolbarHideFileName: false,
            plugins: false,
            showReviewChanges: false // 定义在加载编辑器时自动显示或隐藏审阅更改面板。默认值为 false。
          }
        },
        documentType: docType, // text-text、sheet-spreadsheet、ppt-presentation
        width: '100%',
        height: '100%'
      }
      // eslint-disable-next-line no-undef
      this.DocEditor = new DocsAPI.DocEditor('vabOnlyOffice', config)
    }
  }
}
</script>

<template>
  <div id="vabOnlyOffice"></div>
</template>

<style lang="scss" scoped>
</style>
